import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, EntityService, SharedService } from '@app/core';
import { markPlanExpiryPopupPending } from '@core/helpers/plan-expiry';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnDestroy {
    private destroy$ = new Subject<void>();
  token: any;
  Owner = "Owner";
  Admin = "Admin";

  constructor(
    private readonly authService: AuthService,
    private readonly sharedService: SharedService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly entityService: EntityService) {

            const params = this.route.snapshot.queryParams;
            const hash = typeof window !== 'undefined' ? window.location.hash : '';
            const hashData = hash.startsWith('#data=')
              ? decodeURIComponent(hash.slice('#data='.length))
              : null;
            const code = params['code'];

            // Drop code / leftover hash from history, Referer, and the address bar
            // before any further navigation or API work.
            this.stripCallbackUrl();

            if (code) {
              this.authService.exchangeGoogleCode(code).pipe(takeUntil(this.destroy$)).subscribe({
                next: (parsedData) => this.completeLogin(parsedData),
                error: () => this.router.navigate(['/login'])
              });
              return;
            }

            // Deploy overlap: old backends still redirected with #data=<base64>.
            const data = hashData || params['data'];
            if (data) {
              try {
                this.completeLogin(JSON.parse(atob(data)));
              } catch (error) {
                console.log('error:', error);
                this.router.navigate(['/login']);
              }
              return;
            }

            this.router.navigate(['/login']);

  }

    private stripCallbackUrl(): void {
      if (typeof history !== 'undefined' && history.replaceState && typeof window !== 'undefined') {
        history.replaceState(null, '', window.location.pathname);
      }
    }

    private completeLogin(parsedData: any): void {
      const user = this.sharedService.parseJsonValue(parsedData.user);
      this.authService.authenticate({ ...parsedData, user: user, expiry: new Date(parsedData.expiry) }, true);
      markPlanExpiryPopupPending();

      if ((user.role == this.Owner && user.isOnboarded) || user.role == this.Admin) {
        this.entityService.fetchEntities().pipe(takeUntil(this.destroy$)).subscribe(entities => {
          this.entityService.setInitialEntities(entities, user);
          if (user.role == this.Owner) {
            this.router.navigate(['/dashboard']);
          } else if (user.role == this.Admin) {
            this.router.navigate(['/invoice']);
          }
        }, (error) => {
          console.log('error:', error);
        });
      } else {
        this.router.navigate(['/dashboard']);
      }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
